import {faAtom} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Tooltip} from 'antd';
import {useCallback, useState} from 'react';

import {Text} from '../../../../../../../../../component/text/text';
import {useLicenses} from '../../../../../../../../../provider/license/license-hook';
import {Locale} from '../../../../../../../../../provider/locale/localization';
import {HelpLinkFeatureFlagEnum} from '../../../../../../../../../service/feature-flags/feature-flag-const';
import {useFeatureFlag} from '../../../../../../../../../service/feature-flags/use-feature-flag';
import {
    PostAiSuggestApplyType,
    PostAiSuggestHookType,
    PostSourceEnum,
} from '../../../../../../../../../service/posts/posts-types';
import {FeaturesEnum} from '../../../../../../../../../service/user/user-type';

import {AiGenerationModal} from './ai-generation-modal';
import {LegacyPostAiSuggest} from './legacy-post-ai-suggest';
import * as styles from './post-ai-suggest.scss';

type PropsType = {
    suggestSettings: PostAiSuggestHookType;
    onApplySuggest: (value: PostAiSuggestApplyType) => Promise<void> | void;
    catalog?: PostSourceEnum;
};

export function PostAiSuggest(props: PropsType): JSX.Element {
    const {suggestSettings, onApplySuggest, catalog} = props;

    const isAiV2Enabled = useFeatureFlag(HelpLinkFeatureFlagEnum.aiPostGenerationV2);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const {licenses} = useLicenses();
    const isLicenseActive = Boolean(licenses[FeaturesEnum.posts]?.isActive);

    const handleSelectLegacySuggest = useCallback(
        (text: string) => {
            onApplySuggest({text, image: null, cta: null});
        },
        [onApplySuggest]
    );

    const openModal = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    if (!isAiV2Enabled) {
        return <LegacyPostAiSuggest onSelectSuggest={handleSelectLegacySuggest} suggestSettings={suggestSettings} />;
    }

    return (
        <div className={styles.PostAiSuggest}>
            <FontAwesomeIcon className={styles.PostAiSuggest_leftBackgroundIcon} icon={faAtom} />
            <FontAwesomeIcon className={styles.PostAiSuggest_rightBackgroundIcon} icon={faAtom} />

            <Text block className={styles.PostAiSuggest_text} stringKey="POSTS_SUGGESTS__TITLE" />

            <Tooltip title={isLicenseActive ? null : <Locale stringKey="POSTS_AI_GENERATION__NO_LICENSE__TOOLTIP" />}>
                {/* span keeps tooltip working when the button is disabled */}
                <span className={styles.PostAiSuggest_buttonWrapper}>
                    <Button className={styles.PostAiSuggest_button} disabled={!isLicenseActive} onClick={openModal}>
                        <Locale stringKey="POSTS_SUGGESTS__GENERATE" />
                    </Button>
                </span>
            </Tooltip>

            {isOpen && (
                <AiGenerationModal
                    catalog={catalog}
                    onApplySuggest={onApplySuggest}
                    onClose={closeModal}
                    suggestSettings={suggestSettings}
                />
            )}
        </div>
    );
}
